import { Field, Entity } from "typegraph";

@Entity({ update: "topicVotePositive" })
export default class TopicUpvote {
	@Field()
	entityId: number;
}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/TopicUpvote.ts